module.exports = __webpack_public_path__ + "static/media/CommonPaymentFailed.767844ff.svg";